import { Container, Link } from "@mui/material";

import { Info, StyledButton } from "./styles";

const AboutUsEmail = () => {
  return (
    <Container align="center" sx={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
      <Info variant="large" align="center">
        Interested in a Partnership?
      </Info>
      <Link href="mailto:pr@jibjab.com" target="_blank" underline="none">
        <StyledButton id="about-us-email-partnership" size="large" variant="contained" color="primary" fullWidth>
          pr@jibjab.com
        </StyledButton>
      </Link>
      <Info variant="large" align="center">
        Have a product to enhance JibJab?
      </Info>
      <Link href="mailto:pitch@jibjab.com" target="_blank" underline="none">
        <StyledButton id="about-us-email-pitches" size="large" variant="outlined" color="primary" fullWidth>
          pitch@jibjab.com
        </StyledButton>
      </Link>
    </Container>
  );
};

export default AboutUsEmail;
